import { Grid } from '@material-ui/core'
import { ButtonUploadFile } from 'Components/UI/Atoms/ButtonUploadFile'

export const UploadPhotos = (props) => {
  const { change, setChange, onSubmit } = props

  const handleChange = async (e) => {
    const file = e.target.files[0]
    const index = Number(e.target.id) - 1
    if (!file) return
    const newChange = [...change]
    newChange[index] = file
    await onSubmit(file, index)
    setChange(newChange)
  }

  const BUTTONS = [
    {
      id: 1,
      textBefore: 'Subir foto frente',
      textLater: 'Imagen seleccionada',
      variant: 'contained',
      sm: 12,
      xs: 12,
      name: 'frente',
      onChange: handleChange,
      value: change[0],
    },
    {
      id: 2,
      textBefore: 'Subir foto izquierda',
      textLater: 'Imagen seleccionada',
      variant: 'contained',
      sm: 12,
      xs: 12,
      name: 'izquierda',
      onChange: handleChange,
      value: change[1],
    },
    {
      id: 3,
      textBefore: 'Subir foto atras',
      textLater: 'Imagen seleccionada',
      variant: 'contained',
      sm: 12,
      xs: 12,
      name: 'atrás',
      onChange: handleChange,
      value: change[2],
    },
    {
      id: 4,
      textBefore: 'Subir foto derecha',
      textLater: 'Imagen seleccionada',
      variant: 'contained',
      sm: 12,
      xs: 12,
      name: 'derecha',
      onChange: handleChange,
      value: change[3],
    },
    {
      id: 5,
      textBefore: 'Subir foto motor',
      textLater: 'Imagen seleccionada',
      variant: 'contained',
      sm: 12,
      xs: 12,
      name: 'motor',
      onChange: handleChange,
      value: change[4],
    },
    {
      id: 6,
      textBefore: 'Subir foto interior',
      textLater: 'Imagen seleccionada',
      variant: 'contained',
      sm: 12,
      xs: 12,
      name: 'interior',
      onChange: handleChange,
      value: change[5],
    },
  ]

  return (
    <Grid container spacing={2}>
      {BUTTONS.map(({ onChange, id, value, textLater, textBefore, name, xs, sm }) => {
        return (
          <Grid item sm={sm} xs={xs}>
            <ButtonUploadFile
              id={id}
              name={name}
              value={value}
              textLater={textLater}
              textBefore={textBefore}
              onChange={onChange}
              multiple={false}
            />
          </Grid>
        )
      })}
    </Grid>
  )
}
